import { render } from "./SectionBrands.vue?vue&type=template&id=1b7433a1&scoped=true"
import script from "./SectionBrands.vue?vue&type=script&lang=js"
export * from "./SectionBrands.vue?vue&type=script&lang=js"

import "./SectionBrands.vue?vue&type=style&index=0&id=1b7433a1&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7433a1"]])

export default __exports__